module.exports = __webpack_public_path__ + "04_long_gold.f332fe9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_long_gold.png
// module id = goMJ
// module chunks = 0